import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import IppoolReducer from "../reducers/IppoolReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { IppoolConstants } from "../constants/index";
import { saveFile } from "../utils/common";
const initialState = {
  isLoading: true,
  ipPools: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  ippoolSearchResults: [],
  ippool: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isLoadingDownload: false,
  ippoolAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  autoSearchLoading: false,
  isLoading: true,
  isLoadingAutoSearch: true,
  downloadFileType: "",
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const IppoolContext = createContext({
  ...initialState,
  getAllIppool: () => {},
  addIppool: () => {},
  searchIppool: () => {},
  getIppool: () => {},
  updateIppool: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
  autoSearchIppool: () => {},
});

function IppoolProvider({ children }) {
  const [state, dispatch] = useReducer(IppoolReducer, initialState);

  const getAllIppool = async (payload) => {
    try {
      dispatch({
        type: IppoolConstants.FETCH_IPPOOL_REQUEST,
      });
      const response = await axios.post("/radius/ippool/list", payload);

      dispatch({
        type: IppoolConstants.FETCH_IPPOOL_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: IppoolConstants.FETCH_IPPOOL_FAILURE,
      });
    }
  };
  const searchIppool = async () => {
    try {
      const response = await axios.post("/radius/ippool/search", initPayload);
      dispatch({
        type: IppoolConstants.IPPOOL_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: IppoolConstants.IPPOOL_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: IppoolConstants.IPPOOL_SEARCH_FAILURE,
      });
    }
  };
  const addIppool = async (payload) => {
    const response = await axios.post("/radius/ippool/add", payload);
    dispatch({
      type: IppoolConstants.ADD_IPPOOL_REQUEST,
    });
    dispatch({
      type: IppoolConstants.ADD_IPPOOL_SUCCESS,
      payload: response.data,
    });
  };

  const getIppool = async (id) => {
    const response = await axios.get("/radius/ippool/" + id);
    dispatch({
      type: IppoolConstants.GET_IPPOOL_REQUEST,
    });
    dispatch({
      type: IppoolConstants.GET_IPPOOL_SUCCESS,
      payload: response.data,
    });
  };

  const updateIppool = async (payload) => {
    const response = await axios.put("/radius/ippool/update/" + payload.ipPoolId, payload);
    dispatch({
      type: IppoolConstants.UPDATE_IPPOOL_REQUEST,
    });
    dispatch({
      type: IppoolConstants.UPDATE_IPPOOL_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: IppoolConstants.DOWNLOAD_IPPOOL_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/radius/ippool/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "ippool." + fileType);

    dispatch({
      type: IppoolConstants.DOWNLOAD_IPPOOL_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/radius/ippool/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_ippool." + fileType);
    dispatch({
      type: IppoolConstants.DOWNLOAD_IPPOOL_REQUEST,
    });
    dispatch({
      type: IppoolConstants.DOWNLOAD_IPPOOL_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: IppoolConstants.UPLOAD_IPPOOL_REQUEST,
      });
      const response = await axios({
        url: "/radius/ippool/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: IppoolConstants.UPLOAD_IPPOOL_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: IppoolConstants.UPLOAD_IPPOOL_FAILURE,
      });
    }
  };

  const autoSearchIppool = async (payload) => {
    try {
      const response = await axios.post("/radius/ippool/auto-search", payload);
      dispatch({
        type: IppoolConstants.IPPOOL_AUTO_SEARCH_REQUEST,
      });

      dispatch({
        type: IppoolConstants.IPPOOL_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: IppoolConstants.IPPOOL_AUTO_SEARCH_FAILURE,
      });
    }
  };

  return (
    <IppoolContext.Provider
      value={{
        ...state,
        getAllIppool,
        addIppool,
        searchIppool,
        getIppool,
        updateIppool,
        downloadFile,
        sampleFile,
        uploadFile,
        autoSearchIppool,
      }}
    >
      {children}
    </IppoolContext.Provider>
  );
}

export { IppoolContext, IppoolProvider };
